<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="content-chapter1" id="calibre_toc_9" xml:lang="en-GB"><a class="calibre4" href="#/OEBPS/ebook_split_006#_idTextAnchor002">Introduction<span class="calibre4" id="_idTextAnchor044"></span> </a></p>
<p class="body-textx"> </p>
<p class="structue-q">“The law of attraction states that whatever you focus on, think about, read about, and talk about intensely, you’re going to attract more of into your life.”</p>
<p class="quote-author">—Jack Canfield</p>
<p class="body-text1"> </p>
<div class="calibre1" id="calibre_pb_19"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_010.vue?f1cc4f1c